import React from 'react';
import { Container, Row, Col, Button, Card, OverlayTrigger, Tooltip } from 'react-bootstrap'

const PlanDetails = (props) => {

    const currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2
    });

    const currencyFormatterNoCents = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
    });

    // Handles special cases for formatting data:
    // Splits tiered data into multiple rows
    // Detects currency and formats as USD
    const dataFormatter = {
        format: (value, tooltips) => {
            return value
                .replace(' Tier', '\nTier')
                .replace(' %', '%')
                .replace('$ ', '$')
                .split(/[;\n]+/)
                .map((v, i) => {
                    // Look only at words after a colon. If the word is a number, format it as currency
                    if (v && !isNaN(v)) {
                        return currencyFormatterNoCents.format(v);
                    }

                    if (v.includes(':')) {
                        let kvp = v.split(':');

                        let words = kvp[1].split(' ').map(w => {
                            if (w && !isNaN(w)) {
                                return currencyFormatterNoCents.format(w);
                            } else {
                                return w
                            }
                        });

                        v = kvp[0] + ':' + words.join(' ');

                        if (tooltips) {
                            if (v.includes('Tier 1') && tooltips.tier1) {
                                v = addTooltip(v, tooltips.tier1);
                            }
                            else if (v.includes('Tier 2') && tooltips.tier2) {
                                v = addTooltip(v, tooltips.tier2);
                            }
                        }
                    }

                    return (
                        <div key={i}>{v}</div>
                    )
                });
        }
    }

    const addTooltip = (value, tooltip) => 
        <OverlayTrigger placement="right" overlay={<Tooltip>{tooltip}</Tooltip>}><span>{value} <i className='bx bxs-info-circle text-primary' style={{ 'fontSize': '1.5rem' }} /></span></OverlayTrigger>

    return (
        <>
            <Card className={'card-top-reduce-radius' + (props.isSelected ? ' shadow' : '')}>
                <Card.Header className={props.isSelected ? 'bg-primary text-white' : ''}>
                    <Row>
                        <Col lg={2}>
                            <div className="navbar-brand fw-semibold fs-4 my-2">{props.plan.planName}</div>
                        </Col>
                        <Col lg={6}>
                            <p className='my-2 text-capitalize'>{/*{props.plan.description}*/}</p>
                        </Col>
                        <Col lg={4}>
                            <div className="d-flex flex-wrap align-items-center">
                                <div className='star-ratings border-dotted me-3 my-2'>
                                    {/*{*/}
                                    {/*    // Display first n of 5 stars as solid*/}
                                    {/*    [...Array(5)].map((e, i) => {*/}
                                    {/*        let className = 'bx bxs-star';*/}
                                    {/*        if (i >= props.plan.stars) {*/}
                                    {/*            className = 'bx bx-star';*/}
                                    {/*        }*/}
                                    {/*        return <i className={className} key={i}></i>*/}
                                    {/*    })*/}
                                    {/*}*/}
                                </div>
                                <div className="bronze my-2">
                                    {props.plan.rating}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Row className='inner-desc'>
                        <Col md={6} lg={6}>
                            <Container className='d-grid gap-3'>
                                <Row>
                                    <Col className='text-lg-center text-start'>
                                        <h6 className='pre-title border-dotted'>Monthly Premium</h6>
                                        <div className='final-price'><strong>{currencyFormatter.format(props.plan.rate)}</strong></div>
                                    </Col>
                                    <Col className='text-lg-center text-start'>
                                        <h6 className='pre-title border-dotted'>Deductible</h6>
                                        <div className='final-price'>{dataFormatter.format(props.plan.deductiblePerPerson, {tier1: props.plan.tier1Tooltip, tier2: props.plan.tier2Tooltip})}</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>{props.plan.planDescription}</Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col md={6} lg={6} className='text-lg-left text-start'>
                            <Row><Col><h6 className='pre-title border-dotted'>Out-of-pocket max</h6></Col><Col><div>{dataFormatter.format(props.plan.maxOutOfPocketPerPerson)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Doctor visits</h6></Col><Col><div>{props.plan.costPrimaryCare}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Specialist visit</h6></Col><Col><div>{dataFormatter.format(props.plan.costSpecialist)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Generic drugs</h6></Col><Col><div>{dataFormatter.format(props.plan.costGenericDrugs)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Cost ER</h6></Col><Col><div>{dataFormatter.format(props.plan.costER)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Cost Hospital Stay</h6></Col><Col><div>{dataFormatter.format(props.plan.costHospitalStay)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Cost Outpatient Lab Services</h6></Col><Col><div>{dataFormatter.format(props.plan.costOutpatientLabServices)}</div></Col></Row>
                            <Row><Col><h6 className='pre-title border-dotted'>Cost Urgent Care</h6></Col><Col><div>{dataFormatter.format(props.plan.costUrgentCare)}</div></Col></Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <a href={props.plan.planSbcUrl} target="_blank" rel="noreferrer">View Summary of Benefits and Coverage</a>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Row className='align-items-center'>
                        {/*<Col md={4} lg={4}>*/}
                        {/*    <Form.Check*/}
                        {/*        type="checkbox"*/}
                        {/*        id={"compare-" + props.planId}*/}
                        {/*        label="Compare"*/}
                        {/*    />*/}
                        {/*</Col>*/}
                        {/*<Col md={8} lg={8}>*/}
                        <Col>
                            <div className="d-flex align-items-center justify-content-end flex-wrap">
                                <div>
                                    {/*<Button variant='outline-primary' className='me-3' onClick={props.handleToggleModal}>Plan details</Button>*/}
                                    <Button variant='primary' onClick={props.handleSelect}>Enroll in this plan</Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>
        </>
    )
}

export default PlanDetails;
